export default {
  title: 'Make employee learning fun and engaging with Viska',
  body:
    'Viska is an AI powered knowledge game on mobile. Change your traditional corporate training material into a fun game. Viska personalizes training using each employee’s knowledge history and learning speed. Employees learn on their own, without the help of an education manager. Get in touch to create your team on Viska and start making learning personal and fun.',
  button: 'Create a Team'
};



// WEBPACK FOOTER //
// ./src/pages/Landing/content.js